import { render } from "./vbackNewsSet.vue?vue&type=template&id=192b649c&scoped=true"
import script from "./vbackNewsSet.vue?vue&type=script&lang=js"
export * from "./vbackNewsSet.vue?vue&type=script&lang=js"

import "./vbackNewsSet.vue?vue&type=style&index=0&id=192b649c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192b649c"]])

export default __exports__